import React from 'react';
import './Loading.css';
import Navbar from '../../Navbar';

const Loading = ({ isLoading, error }) => {
  // Handle the loading state
  if (isLoading) {
    return (
      <div>
        <Navbar />
        <div id="loader-wrapper">
          <div id="loader-text">Loading...</div>
          <div id="loader" />
          <div className="loader-section section-left" />
          <div className="loader-section section-right" />
        </div>
      </div>
    );
  } else if (error) {
    // Handle the error state
    return <div>Sorry, there was a problem loading the page.</div>;
  } else {
    return null;
  }
};

export default Loading;



// WEBPACK FOOTER //
// ./src/components/helpers/Loading/Loading.js